export default "__VITE_ASSET__De5tFKd2__"